<template>
    <div>
        <b-modal v-model="mostrarModal" @show="iniciarForm()">
            <div slot="modal-title">Relatório de Faturamento dos Serviços</div>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Grupo de Período</label>
                        <b-form-select
                            :plain="true"
                            :options="opcoesPeriodo"
                            v-model="grupoPeriodo"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Fornecedor</label>
                        <b-form-select
                            :plain="true"
                            :options="fornecedores"
                            text-field="razaoSocial"
                            value-field="cpfCnpj"
                            v-model="fornecedor"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Número de Contrato</label>
                        <b-form-select
                            :plain="true"
                            :options="contratos"
                            text-field="contrato"
                            value-field="contrato"
                            v-model="numeroContrato"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Gestor</label>
                        <b-form-select
                            :plain="true"
                            :options="gestores"
                            text-field="gestor"
                            value-field="codGestor"
                            v-model="gestor"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Unidade</label>
                        <b-form-select
                            :plain="true"
                            :options="unidades"
                            text-field="unidade"
                            value-field="unidade"
                            v-model="unidade"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fechar()"
                    class="mr-2"
                    >Cancelar</b-button
                >
                <b-button variant="primary" @click.stop="filtrar()"
                    >Emitir Relatório</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import FornecedoresServicos from '../../fornecedores/FornecedoresServicos'

export default {
    props: {
        servicos: {
            type: Object
        }
    },

    data() {
        return {
            mostrarModal: false,
            grupoPeriodo: '',
            fornecedores: [],
            fornecedor: '',
            contratos: [],
            numeroContrato: '',
            gestores: [],
            gestor: '',
            unidades: [],
            unidade: '',
            opcoesPeriodo: [
                { value: '', text: 'TODOS' },
                { value: 'ate30', text: 'Atraso até 30 dias' },
                { value: '31a45', text: 'Atraso de 31 a 45 dias' },
                { value: '46a60', text: 'Atraso de 46 a 60 dias' },
                { value: 'acima60', text: 'Atraso acima de 60 dias' }
            ]
        }
    },

    methods: {
        iniciarForm() {
            this.$store.dispatch('addRequest')
            
            this.servicos.obterOpcoesFiltro().then((response) => {
                if (response && response.success) {
                    // Unidades
                    this.unidades = response.data.unidades || []
                    this.unidades.unshift({ unidade: 'TODAS' })
                    
                    // Gestores (responsáveis no GESCON)
                    this.gestores = response.data.gestores || []
                    this.gestores.unshift({
                        codGestor: '',
                        gestor: 'TODOS'
                    })
                }
            })

            if (this.fornecedores.length === 0) {
                FornecedoresServicos.obterTodos().then((response) => {
                    if (response && response.success) {
                        this.fornecedores = response.data
                        this.fornecedores.unshift({
                            cpfCnpj: '',
                            razaoSocial: 'TODOS'
                        })
                    }
                })
            }

            // Carregar contratos
            this.servicos.obterContratos().then((response) => {
                if (response && response.success) {
                    this.contratos = response.data.map(item => ({
                        codContrato: item.contrato,
                        contrato: item.contrato
                    }))
                    this.contratos.unshift({
                        codContrato: '',
                        contrato: 'TODOS'
                    })
                } else {
                    this.$toast.error(
                        'Erro ao obter lista de contratos',
                        'ERROR',
                        this.$toastConfig.error
                    )
                }
                this.$store.dispatch('removeRequest')
            }).catch(() => {
                this.$toast.error(
                    'Erro ao obter opções dos filtros',
                    'ERROR',
                    this.$toastConfig.error
                )
                this.$store.dispatch('removeRequest')
            })
        },

        abrir() {
            this.grupoPeriodo = ''
            this.fornecedor = ''
            this.numeroContrato = ''
            this.gestor = ''
            this.unidade = ''
            this.mostrarModal = true
        },

        fechar() {
            this.mostrarModal = false
        },

        filtrar() {
            let filtroDto = {}
            
            if (this.grupoPeriodo) {
                filtroDto.grupoPeriodo = this.grupoPeriodo
            }

            if (this.fornecedor) {
                filtroDto.fornecedor = this.fornecedor
            }

            if (this.numeroContrato) {
                filtroDto.numeroContrato = this.numeroContrato
            }

            if (this.gestor) {
                filtroDto.gestor = this.gestor
            }

            if (this.unidade && this.unidade !== 'TODAS') {
                filtroDto.unidade = this.unidade
            }

            this.$emit('filtrar', filtroDto)
            this.fechar()
        }
    }
}
</script>